/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListPaddocksByOrganizationQueryResponse, ListPaddocksByOrganizationPathParams, ListPaddocksByOrganizationQueryParams, ListPaddocksByOrganization400, ListPaddocksByOrganization401, ListPaddocksByOrganization403, ListPaddocksByOrganization404, ListPaddocksByOrganization409, ListPaddocksByOrganization500 } from "../../types/paddockController/ListPaddocksByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListPaddocksByOrganizationUrl(organizationId: ListPaddocksByOrganizationPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/paddocks` as const }
  return res
}

/**
 * @summary List paddocks across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/paddocks}
 */
export async function listPaddocksByOrganization(organizationId: ListPaddocksByOrganizationPathParams["organizationId"], params?: ListPaddocksByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListPaddocksByOrganizationQueryResponse, ResponseErrorConfig<ListPaddocksByOrganization400 | ListPaddocksByOrganization401 | ListPaddocksByOrganization403 | ListPaddocksByOrganization404 | ListPaddocksByOrganization409 | ListPaddocksByOrganization500>, unknown>({ method : "GET", url : getListPaddocksByOrganizationUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}